// extracted by mini-css-extract-plugin
export default {"container":"FoodFormatSection-module__container__XD1KK","text":"FoodFormatSection-module__text__u3wFO","switch-layout":"FoodFormatSection-module__switch-layout__u2nea"};